import { render, staticRenderFns } from "./ReportsHeader.vue?vue&type=template&id=142dd51a&scoped=true&"
import script from "./ReportsHeader.vue?vue&type=script&lang=js&"
export * from "./ReportsHeader.vue?vue&type=script&lang=js&"
import style0 from "./ReportsHeader.vue?vue&type=style&index=0&id=142dd51a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "142dd51a",
  null
  
)

export default component.exports